import UI from '../../components/ExcerciseTypes/Design/UserInterface';


const json = {
  1: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P8-E1',
    audio: 'img/FriendsPlus/Page8/Audio/audio-e1-p8.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page8/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page8/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/tieude-e1-p8.mp3' },
        { url: 'img/FriendsPlus/Page8/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page8/E1/4.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/Korea.mp3' },
        { url: 'img/FriendsPlus/Page8/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page8/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/VietNam.mp3' },
        { url: 'img/FriendsPlus/Page8/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page8/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/Mexico.mp3' },
        { url: 'img/FriendsPlus/Page8/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page8/E1/10.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/Thailand.mp3' },
        { url: 'img/FriendsPlus/Page8/E1/11.jpg' },

      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page8/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page8/E1/13.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/Australia.mp3' },
        { url: 'img/FriendsPlus/Page8/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page8/E1/15.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/the USA.mp3' },
        { url: 'img/FriendsPlus/Page8/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page8/E1/17.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/Brazil.mp3' },
        { url: 'img/FriendsPlus/Page8/E1/18.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P8-E2',
    audio: 'img/FriendsPlus/Page8/Audio/audio-e2-p8.mp3',
    recorder: true,
    video: 'Videos/e2.p8.mp4',
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page8/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page8/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/tieude-e2-p8.mp3' },
        { url: 'img/FriendsPlus/Page8/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page8/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/hinh1-e2-p8.mp3' },
        { url: 'img/FriendsPlus/Page8/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/hinh2-e2-p8.mp3' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page8/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/hinh3-e2-p8.mp3' },
        { url: 'img/FriendsPlus/Page8/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page8/Audio/hinh4-e2-p8.mp3' },
      ],

    ],
  },
}

export default json;